<template>
  <div class="px-30">
    <template v-if="user">
      <p>
        Checkout cart for:
        <span :style="{ color: primary }">
          {{ fullName }}
        </span>
      </p>
      <OrderSummary :user="user" />
    </template>
  </div>
</template>

<script>
import OrderSummary from "@/components/order-summary/OrderSummary";
import axios from "@/helpers/axios";
export default {
  name: "AdminCheckout",
  components: {
    OrderSummary
  },
  data: () => ({
    user: null
  }),
  computed: {
    fullName() {
      return this.user.firstName + " " + this.user.lastName;
    },
    id() {
      return this.$route.params.id;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  created() {
    axios.get(`/users/${this.id}`).then(response => {
      this.user = response.data.data;
    });
  }
};
</script>
